import { cn } from "@repo/ui";

export function LandingDeferredSectionSkeleton({
	minHeightClass,
}: {
	minHeightClass: string;
}) {
	return (
		<div
			className={cn(
				"w-full shrink-0 bg-slate-100/90 dark:bg-neutral-900/50",
				minHeightClass,
			)}
			aria-hidden
		/>
	);
}
